"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollView = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Utilities_1 = require("icf-search-client-shared/lib/Utilities");
var react_1 = __importStar(require("react"));
var react_jss_1 = __importDefault(require("react-jss"));
var ScrollDiv = (0, react_jss_1.default)({
    scrollDiv: function (_a) {
        var width = _a.width, height = _a.height, top = _a.top, overflow = _a.overflow, background = _a.background, border = _a.border, padding = _a.padding;
        return ({
            // NOTE: -webkit-overflow-scrolling is for iOS safari (I think)
            "-webkit-overflow-scrolling": "touch",
            position: "absolute",
            width: width !== null && width !== void 0 ? width : "100%",
            height: height === 0 || (height !== null && height !== void 0 ? height : 0) > 0 ? "".concat(height, "px") : "100%",
            top: top !== null && top !== void 0 ? top : 0,
            boxSizing: "border-box",
            zIndex: 50,
            transitionProperty: "height",
            transitionDuration: "250ms",
            transitionTimingFunction: "cubic-bezier(0.21, 0.405, 0.055, 1.02)",
            overflow: overflow !== null && overflow !== void 0 ? overflow : "auto",
            background: background !== null && background !== void 0 ? background : "inherit",
            border: border !== null && border !== void 0 ? border : "inherit",
            padding: padding !== null && padding !== void 0 ? padding : "0px",
        });
    },
})((0, react_1.forwardRef)(function (_a, ref) {
    var classes = _a.classes, width = _a.width, height = _a.height, top = _a.top, overflow = _a.overflow, background = _a.background, border = _a.border, padding = _a.padding, props = __rest(_a, ["classes", "width", "height", "top", "overflow", "background", "border", "padding"]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.scrollDiv, ref: ref }, props)));
}));
function touchOrPointerPosition(e) {
    return e.touches[0].pageY;
}
var ScrollView = /** @class */ (function (_super) {
    __extends(ScrollView, _super);
    function ScrollView() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this._listeners = [];
        _this._container = null;
        return _this;
    }
    ScrollView.prototype.componentDidMount = function () {
        var el = this._container;
        var startY = 0;
        var startHandler = function (e) {
            startY = touchOrPointerPosition(e);
        };
        var moveHandler = function (e) {
            var deltaY = startY - touchOrPointerPosition(e);
            if ((el.scrollHeight - el.scrollTop === el.clientHeight && deltaY > 0) || (el.scrollTop === 0 && deltaY < 0)) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            }
        };
        this._listeners.push((0, Utilities_1.subscribeToEvent)(el, function (ael) { return ael("touchstart", startHandler, true); }));
        this._listeners.push((0, Utilities_1.subscribeToEvent)(el, function (ael) { return ael("touchmove", moveHandler, true); }));
    };
    ScrollView.prototype.componentWillUnmount = function () {
        while (this._listeners.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- length check above
            this._listeners.pop().dispose();
        }
    };
    ScrollView.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)(ScrollDiv, __assign({}, this.props, { ref: function (el) {
                _this._container = el;
            } })));
    };
    return ScrollView;
}(react_1.default.Component));
exports.ScrollView = ScrollView;
//# sourceMappingURL=ScrollView.js.map